/**
 * O navegador não arrasta nada do jogo.
 *
 * Arrastar aqui é mecânica de jogo, como levar um jogador do banco para o
 * campo, e é feito com eventos de ponteiro. O arrasto nativo do navegador só
 * atrapalhava: segurar um rosto, um escudo ou um link puxava uma cópia
 * fantasma da imagem, e às vezes cancelava o gesto do jogo no meio. Soltar um
 * arquivo em cima da janela, por sua vez, fazia o navegador abrir o arquivo e
 * trocar a página, levando a partida junto.
 *
 * Quem um dia precisar do arrasto nativo marca o elemento com
 * `draggable="true"`, e ele passa. Quem precisar receber arquivo solto marca a
 * área com `data-aceita-soltar`.
 */
export function bloquearArrastoNativo(): void {
  document.addEventListener("dragstart", (evento) => {
    const alvo = evento.target instanceof Element ? evento.target : null;
    if (alvo?.closest('[draggable="true"]')) return;
    evento.preventDefault();
  });

  const semSoltarArquivo = (evento: DragEvent): void => {
    const alvo = evento.target instanceof Element ? evento.target : null;
    if (alvo?.closest("[data-aceita-soltar]")) return;
    evento.preventDefault();
  };
  window.addEventListener("dragover", semSoltarArquivo);
  window.addEventListener("drop", semSoltarArquivo);
}
